import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentWrapper from "../../../Wrapper";
import * as accountActions from "../../store/actions/account_list_actions";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import { ContentWithCardLoading } from "../../../../components/loading";
import { CustomSubHeader } from "../../../../components/subheader";
import { useHistory } from "react-router-dom";
import { Form } from "react-bootstrap";
import _ from "lodash";

const tagMap = {
  "trailing": "Trailing",
  "inactive_30d": "Inactive 30 days",
  "subscription": "Subscribed",
  "custom_subscription": "Custom Subscription",
  "wallet": "Wallet Paid",
  "free": "Free Plan"
}
export default function AccountList() {
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [search, setSearch] = useState("");
  const allAccounts = useSelector((state) => state.accounts.allAccounts);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(accountActions.getListOfAccountsRequest({ limit: 10, page: 1, searchText: "" }));
  }, [dispatch]);

  const debouncedSearch = useCallback(
    _.debounce((searchText) => {
      dispatch(accountActions.getListOfAccountsRequest({ limit, page: pageNo, searchText }));
    }, 500),
    [dispatch, limit, pageNo]);

  const handleSearchChange = (e) => {
    const searchText = e.target.value;
    setSearch(searchText);
    setPageNo(1);
    debouncedSearch(searchText);
  };
  const handlePageChange = (page) => {
    dispatch(accountActions.getListOfAccountsRequest({ limit: limit, page: page, searchText: search }));
    setPageNo(page);
  }

  return (
    <ContentWrapper subHeader={<CustomSubHeader>
      <div className="d-flex w-100 flex-stack">
        <div className=""></div>
        <div className="w-300px">
          <Form.Control
            value={search}
            onChange={handleSearchChange}
            placeholder="Search here..."
          />
        </div>
      </div>
    </CustomSubHeader>}>
      {allAccounts.loading ? (
        <ContentWithCardLoading />
      ) : allAccounts.data.length === 0 ? (
        "No accounts"
      ) : (
        // <CustomEmptyPage
        //   page="blockContact"
        //   setShowAdd={() => {
        //     setShow(true);
        //     setIsEdit(false);
        //   }}
        // />
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Company Name", apiKeyName: "companyName", fieldInputType: "INPUT" },
                { title: "Owner Full Name", apiKeyName: "ownerName", fieldInputType: "INPUT" },
                { title: "Owner Email", apiKeyName: "ownerEmail", fieldInputType: "INPUT" },
                { title: "Owner Phone", apiKeyName: "ownerPhone", fieldInputType: "INPUT" },
                { title: "Country", apiKeyName: "country", fieldInputType: "INPUT" },
                { title: "No of Users", apiKeyName: "totalUsers", fieldInputType: "INPUT" },
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Joined Date", apiKeyName: "joinedDate", fieldInputType: "DATE_TIME" },
                { title: "Type Of Company", apiKeyName: "typeOfComp", fieldInputType: "INPUT" },
                { title: "Interested In", apiKeyName: "interestedIn", fieldInputType: "INPUT" },
                { title: "Tags", apiKeyName: "tags", fieldInputType: "INPUT" },
                { title: "Last Activity", apiKeyName: "lastActiveAt", fieldInputType: "DATE_TIME" },
                { title: "Account Delete Email Sent At", apiKeyName: "noti1SentAt", fieldInputType: "DATE_TIME" },
                // { title: "UTM Campaign", apiKeyName: "utm_campaign", fieldInputType: "INPUT" },
                // { title: "UTM Content", apiKeyName: "utm_content", fieldInputType: "INPUT" },
                // { title: "UTM Medium", apiKeyName: "utm_medium", fieldInputType: "INPUT" },
                // { title: "UTM Source", apiKeyName: "utm_source", fieldInputType: "INPUT" },
                // { title: "UTM Term", apiKeyName: "utm_term", fieldInputType: "INPUT" },
                { title: "User Per Account", apiKeyName: "action", fieldInputType: "INPUT", isAction: true, options: ["enter"] },
              ]}
              data={allAccounts.data.map((item) => {
                return {
                  ...item,
                  interestedIn: item.interestedIn?.join(", ") || "",
                  utm_campaign: item.utm?.utm_campaign || "",
                  utm_content: item.utm?.utm_content || "",
                  utm_medium: item.utm?.utm_medium || "",
                  utm_source: item.utm?.utm_source || "",
                  utm_term: item.utm?.utm_term || "",
                  tags: (item.tags || []).map((tag) => tagMap[tag] || tag).join(", ") || "",
                };
              })}
              limit={limit}
              pageNo={pageNo}
              setLimit={setLimit}
              setPageNo={handlePageChange}
              count={allAccounts.Count}
              // actions
              handleEnter={(data) => history.push(`/accounts/${data._id}/campaigns`)}
            />
          </div>
        </div>
      )}
    </ContentWrapper>
  );
}
